import React from 'react';
import Styles from './styles.module.sass';

const CardEndingPayPlan = (props) =>{
    const {
        singlePlanData
    } = props

    return(
        <div className={Styles?.contImaTarjeta}>
            <p>Tu tarjeta Sears</p>
            <div className={Styles?.cardImage}>****{singlePlanData?.cardending}</div>
        </div>
    )
}

export default CardEndingPayPlan;